import React, { useRef, useState, useEffect } from 'react';
import { Avatar, Box, Button, Chip, IconButton, List, ListItem, ListItemAvatar, ListItemText, Popover, Tooltip, Typography } from '@mui/material';
import { FiArchive } from 'react-icons/fi';
import { Link as LinkDom, useParams, useLocation } from 'react-router-dom';
import { Link } from '@mui/material';
import { GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector, GridToolbarQuickFilter } from '@mui/x-data-grid';
import AccessAlarm from '@mui/icons-material/AccessAlarm';
import Delete from '@mui/icons-material/Delete';
import LinkedIn from '@mui/icons-material/LinkedIn';
import RemoveRedEye from '@mui/icons-material/RemoveRedEye';
import Send from '@mui/icons-material/Send';
import AddBox from '@mui/icons-material/AddBox';
import NotesOutlined from '@mui/icons-material/NotesOutlined';
import FiberNewIcon from '@mui/icons-material/FiberNew';
import Update from '@mui/icons-material/Update';
import { IoMdReturnLeft } from 'react-icons/io';
import { v4 } from 'uuid';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import FormNoteModal from '../../components/FormNoteModal/FormNoteModal';
import DialogDeleteCustom from '../../components/DialogDeleteCustom/DialogDeleteCustom';
import SelectionModal from '../Dashboard/Modals/SelectionModal';
import ChooseMultipleSelectionModal from './Modals/ChooseMultipleSelectionModal';
import ShowAddCvCandidat from '../Candidat/VisualiserCandidat/ShowAddCvCandidat';
import { displaySwipeableDrawerSummaryCandidat } from '../../redux/SwipeableDrawer/actions/swipeableDrawerActions';
import { setToggleMailing } from '../../redux/toggle/actions/toggleActions';
import { SetSelectedCandidatBeAddToSelection } from '../../redux/candidats/actions/candidatsActions';
import { deleteCandidatFromSelection, getAllCandidatsInSelection } from '../../services/SelectionCandidatService';
import { addNoteCandidat } from '../../services/NoteCandidat';
import { removeLineBreak } from '../../utils/EditorUtil';
import { withSnackbar } from '../../utils/SnackbarHOC';
import { getUserData, useQuery, getSenioriteFromDate } from '../../utils/FunctionHelpers';
import { commonGridSx, gridLocaleText } from '../../utils/gridStyles';
import { emptyRowSelection, getSelectedRowIds } from '../../utils/gridSelection';
import { DataGrid } from '../../components/SortableDataGrid/SortableDataGrid';

const taskClassColor = (value) => {
  if (value === 1) return '#ef4444';
  if (value === 2) return '#3b82f6';
  if (value === 3) return '#16a34a';
  return '#94a3b8';
};

const normalizePreavisToDays = (raw) => {
  if (!raw || raw === 'null') return -1;
  const s = String(raw).trim().toLowerCase();
  if (['immediat', 'immédiat', 'immediate', 'immédiate'].includes(s)) return 0;
  const n = parseInt(s.match(/\d+/)?.[0] ?? '', 10);
  if (Number.isNaN(n)) return -1;
  if (s.includes('jour')) return n;
  if (s.includes('semaine')) return n * 7;
  if (s.includes('mois')) return n * 30;
  return n;
};

const normalizeDateDispoToTs = (raw) => {
  if (!raw || raw === 'null' || raw === '-') return -1;
  const m = moment(String(raw).trim(), ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601], true);
  if (m.isValid()) return m.valueOf();
  const s = String(raw).trim().toLowerCase();
  if (['immediat', 'immédiat', 'asap'].includes(s)) return 0;
  return -1;
};

const normalizeDateToTimestamp = (value) => {
  const dateValue = value?.date ?? value;
  return dateValue ? moment(dateValue).toDate().getTime() : null;
};

const CandidatsListInSelection = ({ history, snackbarShowMessage }) => {
  const [loading, setLoading] = useState(false);
  const [candidats, setCandidats] = useState([]);
  const [reloadSelections, setReloadSelections] = useState(false);
  const { idSelection } = useParams();
  const query = useQuery();
  const [openDialogDelete, setOpenDialogDelete] = useState(false);
  const [candidatInfos, setCandidatInfos] = useState({ uuid: '', nom: '', prenom: '' });
  const [loadingToDelete, setLoadingToDelete] = useState(false);
  const [candidatsCount, setCandidatsCount] = useState(0);
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
  const [sortModel, setSortModel] = useState([{ field: 'updatedAt', sort: 'desc' }]);
  const location = useLocation();
  const mounted = useRef(true);
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [pj, setPj] = useState(null);
  const [selectedCandidatId, setSelectedCandidatId] = useState(null);
  const [deleteCandidatFromSelectionDialogOpen, setDeleteCandidatFromSelectionDialogOpen] = useState(false);
  const [candidatIds, setCandidatIds] = useState([]);
  const [rowSelectionModel, setRowSelectionModel] = useState(emptyRowSelection);
  const [popoverState, setPopoverState] = useState({ anchorEl: null, selections: [] });

  const selectedCandidatForSelection = useSelector((state) => state.candidats.candidatsSelectedForSelection);

  useEffect(() => {
    if (selectedCandidatForSelection?.length) setCandidatIds(selectedCandidatForSelection);
  }, [selectedCandidatForSelection]);

  useEffect(() => {
    const savedPage = localStorage.getItem('currentPageSelection');
    if (savedPage) setPaginationModel((m) => ({ ...m, page: parseInt(savedPage, 10) }));
  }, []);

  useEffect(() => {
    localStorage.setItem('currentPageSelection', paginationModel.page);
  }, [paginationModel.page]);

  const getSortColumn = (field) => field === 'prequalifClientRhAt' ? 'dateAccrochage' : field;

  const fetchCandidats = async (page = paginationModel.page, sort = sortModel, pageSize = paginationModel.pageSize) => {
    setLoading(true);
    setCandidats([]);
    try {
      const { data } = await getAllCandidatsInSelection(idSelection, {
        page: page + 1,
        limit: pageSize,
        sortOrder: (sort[0]?.sort || 'desc').toUpperCase(),
        ...(sort[0]?.field && { sortColumn: getSortColumn(sort[0].field) }),
      });
      setCandidats(data.candidats || []);
      setCandidatsCount(data.count || 0);
    } catch {
      snackbarShowMessage('Erreur de chargement de données.', 'error', 4000);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (idSelection === 'undefined') { history.push({ pathname: '/selections' }); return; }
    fetchCandidats(paginationModel.page, sortModel, paginationModel.pageSize);
  }, [reloadSelections, idSelection, paginationModel.page, paginationModel.pageSize, sortModel]);

  const viewCandidat = (row, openInNewTab = false) => {
    const candidatsIds = candidats.map((c) => c.id);
    localStorage.setItem('currentPageSelection', paginationModel.page);
    const stateData = {
      currentIndex: 0,
      candidatsInList: candidatsIds,
      candidatIndex: candidatsIds.indexOf(row.id),
      selectionName: location.state?.selectionName,
      numbersTotalOfSelections: candidats.length,
    };
    const url = `/selections/${idSelection}/candidats/${row.id}/view`;
    if (openInNewTab) {
      localStorage.setItem('viewCandidatState', JSON.stringify(stateData));
      window.open(url, '_blank');
    } else {
      history.push({ pathname: url, state: stateData });
    }
  };

  const handleOpenNoteModal = (uuid) => { setSelectedCandidatId(uuid); setOpenModal(true); };
  const handleCloseNoteModal = () => { setOpenModal(false); setErrors({}); setPj(null); };

  const handleSubmitNote = async (comments) => {
    if (!comments || comments.trim() === '') { setErrors({ commentaire: "Le champ 'COMMENTAIRE' est obligatoire." }); return; }
    const formData = new FormData();
    formData.append('dateTime', new Date());
    formData.append('commentaire', removeLineBreak(comments));
    formData.append('auteur', getUserData().uuid);
    formData.append('candidat', selectedCandidatId);
    formData.append('pj', pj);
    try {
      snackbarShowMessage('Patientez svp!', 'warning', null);
      const response = await addNoteCandidat(formData);
      snackbarShowMessage(response.data);
    } catch {
      snackbarShowMessage("Une erreur est survenue lors d'ajout d'une note", 'error', 4000);
    } finally {
      setLoading(false);
      handleCloseNoteModal();
    }
  };

  const handleOpenDialog = (row) => { setCandidatInfos({ uuid: row.id, nom: row.nom, prenom: row.prenom }); setOpenDialogDelete(true); };
  const handleCloseDialog = () => { if (!loadingToDelete) setOpenDialogDelete(false); };

  const handleDeleteCandidat = async () => {
    setLoadingToDelete(true);
    const res = await deleteCandidatFromSelection(candidatInfos.uuid, idSelection);
    if (!mounted.current) return;
    setLoadingToDelete(false);
    snackbarShowMessage(res.data);
    handleCloseDialog();
    setReloadSelections(!reloadSelections);
  };

  const handleDeleteCandidatsFromSelection = async () => {
    setLoadingToDelete(true);
    try {
      for (const id of candidatIds) await deleteCandidatFromSelection(id, idSelection);
      snackbarShowMessage('Candidats supprimés avec succès', 'success', 4000);
    } catch {
      snackbarShowMessage('Erreur lors de la suppression des candidats', 'error', 4000);
    } finally {
      setLoadingToDelete(false);
      setDeleteCandidatFromSelectionDialogOpen(false);
      setTimeout(() => window.location.reload(), 1000);
    }
  };

  const handleRowSelectionModelChange = (newSelection) => {
    setRowSelectionModel(newSelection);
    const ids = getSelectedRowIds(newSelection, rows);
    setCandidatIds(ids);
    dispatch(SetSelectedCandidatBeAddToSelection(ids));
  };

  // 'exclude' means "select all" was ticked.
  const showButtonMailing = rowSelectionModel.type === 'exclude' || rowSelectionModel.ids.size > 0;

  const CustomToolbar = () => (
    <GridToolbarContainer sx={{ px: 2, py: 1.25, borderBottom: '1px solid #f1f5f9', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
      <Box sx={{ mr: 'auto' }}>
        <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#0f172a' }}>
          SÉLECTION : {query.get('selectionName')} <Chip label={candidatsCount} size="small" sx={{ background: '#ebf4fb', color: '#03407b', fontWeight: 700, fontSize: '0.8125rem', ml: 0.5 }} />
        </Typography>
        <Typography sx={{ fontSize: '1rem', color: '#64748b' }}>CONSULTANT : {query.get('consultant')}</Typography>
      </Box>
      {showButtonMailing ? (
        <>
          <Button variant="contained" onClick={() => setDeleteCandidatFromSelectionDialogOpen(true)}
            sx={{ textTransform: 'none', fontWeight: 500, fontSize: '1rem', background: '#dc2626', '&:hover': { background: '#b91c1c' }, borderRadius: 2, px: 2, py: 0.75, whiteSpace: 'nowrap' }}>
            Supprimer de la sélection
          </Button>
          <ChooseMultipleSelectionModal
            selectedCandidats={candidatIds} currentSelection={idSelection}
            snackbarShowMessage={snackbarShowMessage} reloadSelections={reloadSelections} setReloadSelections={setReloadSelections}>
            {(handleOpenAddToSelection) => (
              <Button variant="contained" onClick={handleOpenAddToSelection}
                sx={{ textTransform: 'none', fontWeight: 500, fontSize: '1rem', background: '#0ea5e9', '&:hover': { background: '#0284c7' }, borderRadius: 2, px: 2, py: 0.75, whiteSpace: 'nowrap' }}>
                Ajouter à une sélection
              </Button>
            )}
          </ChooseMultipleSelectionModal>
          <SelectionModal
            selectedCandidats={candidatIds} history={history} snackbarShowMessage={snackbarShowMessage}
            isModify={false} setReloadSelections={setReloadSelections} reloadSelections={reloadSelections}>
            {(handleOpenAddSelection) => (
              <Button variant="contained" onClick={handleOpenAddSelection}
                sx={{ textTransform: 'none', fontWeight: 500, fontSize: '1rem', background: '#03407b', '&:hover': { background: '#02357a' }, borderRadius: 2, px: 2, py: 0.75, whiteSpace: 'nowrap' }}>
                Créer une sélection
              </Button>
            )}
          </SelectionModal>
          <Button variant="contained" onClick={() => dispatch(setToggleMailing(true))} endIcon={<Send />}
            sx={{ textTransform: 'none', fontWeight: 500, fontSize: '1rem', background: '#03407b', '&:hover': { background: '#02357a' }, borderRadius: 2, px: 2, py: 0.75 }}>
            Mailing
          </Button>
        </>
      ) : (
        <Button onClick={() => history.goBack()} variant="outlined" disabled={loading}
          sx={{ textTransform: 'none', fontWeight: 500, fontSize: '1rem', color: '#64748b', borderColor: '#e2e8f0', borderRadius: 2, px: 2, py: 0.75 }}>
          <IoMdReturnLeft style={{ marginRight: 6, fontSize: 18 }} />
          Retourner
        </Button>
      )}
      <GridToolbarQuickFilter
        sx={{
          '& .MuiInputBase-root': { borderRadius: 2, fontSize: '1rem', background: '#f8fafc', px: 1.5, height: 36 },
          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0' },
          '& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#7fb3d3' },
          '& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#03407b' },
        }}
        placeholder="Rechercher..."
        debounceMs={400}
      />
      <GridToolbarColumnsButton sx={{ textTransform: 'none', fontSize: '1rem', color: '#64748b', borderRadius: 2 }} />
      <GridToolbarFilterButton sx={{ textTransform: 'none', fontSize: '1rem', color: '#64748b', borderRadius: 2 }} />
      <GridToolbarDensitySelector sx={{ textTransform: 'none', fontSize: '1rem', color: '#64748b', borderRadius: 2 }} />
    </GridToolbarContainer>
  );

  const columns = [
    {
      field: 'numCandidat', headerName: 'N°', width: 80,
      renderCell: (p) => {
        const files = p.row.uploadedFiles || [];
        const candidatName = `${p.row.nom} ${p.row.prenom}`;
        return <ShowAddCvCandidat snackbarShowMessage={snackbarShowMessage} files={files} fileName={candidatName}>{p.value}</ShowAddCvCandidat>;
      },
    },
    {
      field: 'nom', headerName: 'NOM', width: 130,
      renderCell: (p) => (
        <Link component="button"
          onClick={(e) => { const openInNewTab = e.ctrlKey || e.metaKey; viewCandidat(p.row, openInNewTab); }}
          sx={{ textDecoration: 'none', color: '#0ea5e9', fontWeight: 600, fontSize: '1rem' }}>
          {p.value}
        </Link>
      ),
    },
    {
      field: 'prenom', headerName: 'PRÉNOM', width: 140,
      renderCell: (p) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Tooltip title="Voir résumé">
            <IconButton size="small"
              onClick={() => dispatch(displaySwipeableDrawerSummaryCandidat({ show: true, id: p.row.id }))}
              sx={{ color: '#94a3b8', p: 0.25, '&:hover': { color: '#03407b', background: '#ebf4fb' }, borderRadius: 1, flexShrink: 0 }}>
              <RemoveRedEye sx={{ fontSize: 15 }} />
            </IconButton>
          </Tooltip>
          <Link component="button"
            onClick={(e) => { const openInNewTab = e.ctrlKey || e.metaKey; viewCandidat(p.row, openInNewTab); }}
            sx={{ textDecoration: 'none', color: '#334155', fontSize: '1rem' }}>
            {p.value}
          </Link>
        </Box>
      ),
    },
    {
      field: 'prequalifClientRhAt', headerName: 'PRÉQUALIF RH', width: 130,
      renderCell: (p) => {
        const display = p.value ?? p.row.dateAccrochage;
        return <Typography sx={{ fontSize: '1rem', color: '#64748b' }}>{display ? moment(display).format('DD/MM/YYYY') : '—'}</Typography>;
      },
    },
    {
      field: 'mailSentAt', headerName: 'MAIL (ENVOI)', width: 120,
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', color: '#64748b' }}>
          {p.value?.date ? moment(p.value.date).format('DD/MM/YYYY') : '—'}
        </Typography>
      ),
    },
    {
      field: 'testTechniqueAt', headerName: 'TEST TECHNIQUE', width: 140,
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', color: '#64748b' }}>
          {p.value?.date ? moment(p.value.date).format('DD/MM/YYYY') : '—'}
        </Typography>
      ),
    },
    {
      field: 'testeur', headerName: 'TESTEUR', width: 130,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{p.value ?? '—'}</Typography>,
    },
    {
      field: 'updatedAt', headerName: 'DATE MAJ', width: 110,
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', color: '#64748b' }}>
          {p.value ? moment(p.value).format('DD/MM/YYYY') : '—'}
        </Typography>
      ),
    },
    {
      field: 'pre_avis', headerName: 'PRÉAVIS', width: 110,
      sortComparator: (a, b) => normalizePreavisToDays(a) - normalizePreavisToDays(b),
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', color: '#475569' }}>
          {!p.value || p.value === 'null' ? '—' : p.value}
        </Typography>
      ),
    },
    {
      field: 'dispo_le', headerName: 'DATE DISPO', width: 110,
      sortComparator: (a, b) => normalizeDateDispoToTs(a) - normalizeDateDispoToTs(b),
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', color: '#475569' }}>
          {!p.value || p.value === 'null' ? '—' : p.value}
        </Typography>
      ),
    },
    {
      field: 'dateDebutExperience', headerName: 'XP', width: 70, align: 'center', headerAlign: 'center',
      sortComparator: (a, b) => getSenioriteFromDate(a?.date) - getSenioriteFromDate(b?.date),
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', color: '#475569' }}>
          {p.value ? getSenioriteFromDate(p.value?.date) : 'N/A'}
        </Typography>
      ),
    },
    {
      field: 'fonction', headerName: 'FONCTION', width: 230,
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', color: '#334155', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {p.value || '—'}
        </Typography>
      ),
    },
    {
      field: 'telephone', headerName: 'MOBILE', width: 130,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#334155' }}>{p.value || '—'}</Typography>,
    },
    {
      field: 'email', headerName: 'EMAIL', width: 200,
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', color: '#334155', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {p.value || '—'}
        </Typography>
      ),
    },
    {
      field: 'nom_societe', headerName: 'SOCIÉTÉ', width: 150,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{p.value || '—'}</Typography>,
    },
    {
      field: 'linkedin', headerName: 'LKD', width: 60, align: 'center', headerAlign: 'center', sortable: false,
      renderCell: (p) => p.value ? (
        <Tooltip title="Voir LinkedIn">
          <a href={p.value} target="_blank" rel="noreferrer" style={{ color: '#0a66c2', lineHeight: 0 }}>
            <LinkedIn sx={{ fontSize: 20 }} />
          </a>
        </Tooltip>
      ) : <Typography sx={{ color: '#cbd5e1', fontSize: '1rem' }}>—</Typography>,
    },
    {
      field: 'selections', headerName: 'VIVIERS', width: 90, align: 'center', headerAlign: 'center', sortable: false,
      renderCell: (p) => {
        const sels = p.value || [];
        return (
          <Box
            onMouseEnter={(e) => sels.length > 0 && setPopoverState({ anchorEl: e.currentTarget, selections: sels })}
            onMouseLeave={() => setPopoverState({ anchorEl: null, selections: [] })}
            sx={{ cursor: 'pointer' }}>
            <Chip label={sels.length} size="small"
              sx={{ background: sels.length > 0 ? '#ebf4fb' : '#f1f5f9', color: sels.length > 0 ? '#03407b' : '#94a3b8', fontWeight: 600, fontSize: '0.8125rem', cursor: 'pointer' }} />
          </Box>
        );
      },
    },
    {
      field: 'consultant', headerName: 'TALENT MANAGER', width: 150,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{p.value ?? '—'}</Typography>,
    },
    {
      field: 'sourceur', headerName: 'SOURCEUR', width: 130,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{p.value ?? '—'}</Typography>,
    },
    {
      field: 'changeType', headerName: 'STATUT', width: 90, align: 'center', headerAlign: 'center',
      renderCell: (p) => {
        if (p.value === 'Update') return <Update color="primary" />;
        if (p.value === 'New') return <FiberNewIcon color="error" />;
        return <Typography sx={{ color: '#cbd5e1', fontSize: '1rem' }}>—</Typography>;
      },
    },
    {
      field: 'task', headerName: 'TÂCHES', width: 80, align: 'center', headerAlign: 'center', sortable: false,
      renderCell: (p) => p.value ? (
        <AccessAlarm sx={{ color: taskClassColor(p.value), fontSize: 20 }} />
      ) : <Typography sx={{ color: '#cbd5e1', fontSize: '1rem' }}>—</Typography>,
    },
    {
      field: 'localisation', headerName: 'LOCALISATION', width: 130,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{p.value || '—'}</Typography>,
    },
    {
      field: 'diplome', headerName: 'DIPLÔME', width: 130,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{p.value || '—'}</Typography>,
    },
    {
      field: 'actions_col', headerName: 'ACTIONS', width: 120, sortable: false, filterable: false,
      renderCell: (p) => {
        const currentSelections = p.row.selections || [];
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
            <Tooltip title="Supprimer">
              <IconButton size="small" onClick={() => handleOpenDialog(p.row)}
                sx={{ color: '#ef4444', background: '#fef2f2', borderRadius: '8px', '&:hover': { background: '#fee2e2' }, p: 0.75 }}>
                <Delete sx={{ fontSize: 16 }} />
              </IconButton>
            </Tooltip>
            <ChooseMultipleSelectionModal
              selectedCandidats={[p.row.id]} history={history} snackbarShowMessage={snackbarShowMessage}
              isModify={false} setReloadSelections={setReloadSelections} reloadSelections={reloadSelections}
              currentSelection={currentSelections.map((s) => s.id)}>
              {(handleOpenAffecterSelection) => (
                <Tooltip title="Ajouter à une sélection">
                  <IconButton size="small" onClick={handleOpenAffecterSelection}
                    sx={{ color: '#03407b', background: '#ebf4fb', borderRadius: '8px', '&:hover': { background: '#d6eaf8' }, p: 0.75 }}>
                    <AddBox sx={{ fontSize: 16 }} />
                  </IconButton>
                </Tooltip>
              )}
            </ChooseMultipleSelectionModal>
            <Tooltip title="Ajouter une note">
              <IconButton size="small" onClick={() => handleOpenNoteModal(p.row.id)}
                sx={{ color: '#16a34a', background: '#f0fdf4', borderRadius: '8px', '&:hover': { background: '#dcfce7' }, p: 0.75 }}>
                <NotesOutlined sx={{ fontSize: 16 }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
  ];

  const rows = (candidats || []).map((row) => ({
    ...row,
    id: row.id,
    updatedAt: normalizeDateToTimestamp(row.updatedAt),
    prequalifClientRhAt: normalizeDateToTimestamp(row.prequalifClientRhAt) ?? normalizeDateToTimestamp(row.dateAccrochage),
    dateAccrochage: normalizeDateToTimestamp(row.dateAccrochage),
  }));

  return (
    <Box sx={{ width: '100%', maxWidth: '100%', px: { xs: 1, md: 1.5 }, pb: 2 }}>
      <Box sx={{ width: '100%', maxWidth: '100%', borderRadius: 3, border: '1px solid #e2e8f0', height: 'calc(100vh - 180px)', minHeight: 400, background: '#fff', overflow: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.04)' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          getRowId={(row) => row.id}
          loading={loading}
          paginationMode="server"
          sortingMode="server"
          rowCount={candidatsCount}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[50, 100]}
          sortModel={sortModel}
          onSortModelChange={setSortModel}
          checkboxSelection
          disableRowSelectionOnClick
          rowSelectionModel={rowSelectionModel}
          onRowSelectionModelChange={handleRowSelectionModelChange}
          showToolbar
          slots={{ toolbar: CustomToolbar }}
          slotProps={{ loadingOverlay: { variant: 'skeleton', noRowsVariant: 'skeleton' } }}
          localeText={gridLocaleText}
          sx={commonGridSx}
        />
      </Box>

      <Popover
        sx={{ pointerEvents: 'none' }}
        open={Boolean(popoverState.anchorEl)}
        anchorEl={popoverState.anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        onClose={() => setPopoverState({ anchorEl: null, selections: [] })}
        disableRestoreFocus>
        <List sx={{ p: 1 }}>
          {popoverState.selections.map((sel) => (
            <ListItem key={v4()} dense disableGutters>
              <ListItemAvatar>
                <Avatar sx={{ width: 28, height: 28, background: '#ebf4fb' }}>
                  <FiArchive color="#03407b" size={14} />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={<Typography sx={{ fontSize: '1rem', color: '#334155' }}>{sel?.nom}</Typography>} />
            </ListItem>
          ))}
        </List>
      </Popover>

      <FormNoteModal
        errors={errors} setPj={setPj} loading={false}
        handleSubmit={handleSubmitNote} modalState={openModal}
        handleOpen={handleOpenNoteModal} handleClose={handleCloseNoteModal} showAddButton={false}
        subtitle={(() => {
          const c = rows.find((r) => r.id === selectedCandidatId);
          return c ? `Pour ${c.prenom || ''} ${(c.nom || '').toUpperCase()}`.trim() : undefined;
        })()}
      />
      <DialogDeleteCustom
        handleClose={handleCloseDialog} open={openDialogDelete} handleConfirm={handleDeleteCandidat}
        loading={loadingToDelete}
        label={`Voulez vous vraiment supprimer le candidat "${candidatInfos.nom} ${candidatInfos.prenom}" de la selection`}
        title="Supprimer le candidat?"
      />
      <DialogDeleteCustom
        handleClose={() => setDeleteCandidatFromSelectionDialogOpen(false)}
        open={deleteCandidatFromSelectionDialogOpen}
        handleConfirm={handleDeleteCandidatsFromSelection}
        loading={loadingToDelete}
        label="Voulez vous vraiment supprimer ces candidat de la selection ?"
        title="Supprimer les candidat de la selection ?"
      />
    </Box>
  );
};

export default withSnackbar(CandidatsListInSelection);
